/** Set by the API when the current company is served by the other app (old and new app side by side). */
export const OTHER_APP_HEADER = 'x-inscope-app';

/**
 * Where to go in the other app: its start page after choosing a company there or signing in, otherwise the same page.
 * The address comes from this site's API, never from the page.
 */
export function getOtherAppUrl(
  otherApp: string,
  requestUrl: string | undefined,
  location: { pathname: string; search: string; hash: string }
): string {
  const choosing = /\/tenant\/set-current\//i.test(requestUrl ?? '');
  const path = choosing || location.pathname === '/login' ? '/' : location.pathname + location.search + location.hash;
  return otherApp.replace(/\/+$/, '') + path;
}

/** Leaves for the other app; the returned promise never settles, so the caller stops where it is. */
export function goToOtherApp(otherApp: string, requestUrl: string | undefined): Promise<never> {
  window.location.assign(getOtherAppUrl(otherApp, requestUrl, window.location));
  return new Promise<never>(() => undefined);
}
